webpackJsonp([35783957827783],{

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/business.bea54ed0.jpg";

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.0af11031.ico";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/group2.313360cd.jpg";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/values.b7dc329f.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major imageContainer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Bem-vindo \xE0 AH Business"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "#one", className: "button2 next2 scrolly" },
	                            "Ver mais"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(209);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _business = __webpack_require__(528);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _values = __webpack_require__(135);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _group = __webpack_require__(531);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _favicon = __webpack_require__(49);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription }),
	                _react2.default.createElement('link', { rel: 'shortcut icon', type: 'image/png', href: _favicon2.default })
	            ),
	            'Business',
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _business2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Grupo'
	                            ),
	                            _react2.default.createElement('p', null)
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/group', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _group2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '\xC1reas de Neg\xF3cio'
	                            ),
	                            _react2.default.createElement('p', null)
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/fields', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { className: 'imageContainer', style: { backgroundImage: 'url(' + _values2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'majority' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Valores'
	                            ),
	                            _react2.default.createElement('p', null)
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/values', className: 'link primary' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'two' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(
	                                    'font',
	                                    { color: 'black' },
	                                    'Sobre a AH Bussiness'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'A AH BUSINESS nasce em Setembro de 2004 como resultado do cruzamento de duas fortes voca\xE7\xF5es: empreendedorismo e gest\xE3o.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'A AHBUSINESS assume o compromisso de detetar potencial em empresas, adquirir participa\xE7\xE3o e responsabilizar-se pela gest\xE3o, no sentido de as converter em atividades atrativas e rent\xE1veis para o sector e acionistas. A vontade de fazer crescer a AH BUSINESS tem assim, associada \xE0 capacidade de visualizar oportunidades de neg\xF3cio, a capacidade de lhes dar corpo e vida. A hist\xF3ria profissional e pessoal de cada um \xE9, atrav\xE9s da AH BUSINESS, assimilada e conduzida no sentido de lhe proporcionar um \u201Cnascimento\u201D seguro e um crescimento com futuro. A AHBUSINESS v\xEA-se ent\xE3o como uma equipa de gest\xE3o de um portf\xF3lio de neg\xF3cios diversificado e, simultaneamente, de refer\xEAncia no setor respetivo.'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/group', className: 'button next' },
	                                    'Ver mais'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-00da5043134c9fe60a63.js